/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UserAllocationSearchRequestDto interface.
 */
export function instanceOfUserAllocationSearchRequestDto(value) {
    return true;
}
export function UserAllocationSearchRequestDtoFromJSON(json) {
    return UserAllocationSearchRequestDtoFromJSONTyped(json, false);
}
export function UserAllocationSearchRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startMonth': json['startMonth'] == null ? undefined : json['startMonth'],
        'startYear': json['startYear'] == null ? undefined : json['startYear'],
        'endMonth': json['endMonth'] == null ? undefined : json['endMonth'],
        'endYear': json['endYear'] == null ? undefined : json['endYear'],
    };
}
export function UserAllocationSearchRequestDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'startMonth': value['startMonth'],
        'startYear': value['startYear'],
        'endMonth': value['endMonth'],
        'endYear': value['endYear'],
    };
}
